// ImageEditorWrapper.tsx
import React, { useEffect, useRef, useState } from "react";
import StepsHeader from "../../section/steps-header";
import PolygonDrawer from "../new-canvas";
import Classification from "../classification";
import VisionTraining from "../../../pages/ai-magic-studio/magics/vision-training";
import NotFound from "../../../pages/not-found";
import ModalPageFooter from "../../global-layout/modal-page-footer";
import { SecondaryTextBtn } from "../../form/text-btn";
import IconBtn from "../../form/icon-btn";
import { DeleteIcon, EditIcon, PageModalCloseIcon } from "../../svg";
import { magicListFetch } from "../../../services/authFunctions";
import { magicServices } from "../../../services/InspectionOneServices";
import { useMyContext } from "../../my-context/MyContext";
import Skeleton from "react-loading-skeleton";

type ImageEditorWrapperProps = {
  data: any;
  setCurrentStep: any
  handleSubmit: any
  setData: any
};

const ImageEditorWrapper: React.FC<ImageEditorWrapperProps> = ({
  data,
  setCurrentStep,
  handleSubmit,
  setData,
}) => {
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [selectedSidebar, setSelectedSidebar] = useState<any>(null);
  const [galleryImage, setgalleryImage] = useState<any[]>([]);
  const [iterationsData, setIterationsData] = useState<any[]>([]);
  const [iteration, setIteration] = useState<any>();
  const [currentPage, setCurrentPage] = useState<any>(1);
  const [totalPages, setTotalPages] = useState<any>(1);
  const { autoNavigate } = useMyContext();
  const [dynamicHeight, setDynamicHeight] = useState(0);
  const elementRef = useRef<any>(null);
  const [isLoading, setIsloading] = useState(false);
  const [sasToken, setSasToken] = useState("");

  const openEditor = () => {
    setIsEditorOpen(true);
  };

  const handleNext = () => {
    setCurrentStep(3);
  };
  const handlePrevious = () => {
    setCurrentStep(1);
  };
  const handleSaveDraft = () => {
    handleSubmit();
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev: any) => prev - 1);
      handleGetLabelDetailFetch(iteration, currentPage - 1); // call API or update galleryImage
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev: any) => prev + 1);
      handleGetLabelDetailFetch(iteration, currentPage + 1); // call API or update galleryImage
    }
  };

  const handleGetLabelDetailFetch = async (iteration: number, pageNumber: any = 1) => {
    setIsloading(true)
    // setIterationsData([]);
    setgalleryImage([]);
    try {
      const requestData = {
        uniqueId: data.uniqueId,
        iteration,
        pageCount: 20,
        pageNumber: pageNumber,
      };
      const response = await magicServices.MagicLabelDetailfetch(requestData);
      if (response.success) {
        const labels = response.data?.labels || [];
        setSasToken(response.data.sasToken);
        setIterationsData(response.data?.iterationsList);
        const galleryImages = labels
          .filter((label: { magicUrl: any }) => label.magicUrl)
          .map(
            (label: {
              magicUrl: any;
              width: any;
              height: any;
              uniqueId: any;
            }) => ({
              url: label.magicUrl,
              width: label.width || 0,
              height: label.height || 0,
              uniqueId: label.uniqueId,
            })
          );

        setgalleryImage(galleryImages);
        setTotalPages(Math.ceil(response.data?.totalCount / 20));
      }
      setIsloading(false)
    } catch (error) {
      console.error("Error fetching labels", error);
      setIsloading(false)
    }
  };

  const getIterationValue = (sidebar: any) => {
    if (sidebar == null) return 0;
    else return sidebar.iteration;
  };


  const handleStartTraining = async () => {
    try {
      const requestData = {
        uniqueId: data.uniqueId,
        currentIteration: iteration
      };
      const response = await magicServices.MagicTrainingSave(requestData);

      if (response.success) {
        setIteration(iteration);
        setSelectedSidebar(null);
        handleGetLabelDetailFetch(iteration);
      }
    }
    catch (error) {

    }
  };

  useEffect(() => {
    const iteration = getIterationValue(selectedSidebar);
    setIteration(iteration)
    handleGetLabelDetailFetch(iteration);
  }, [selectedSidebar]);

  useEffect(() => {
    if (autoNavigate.isNavigate) {
      openEditor()
    }
    if (elementRef.current) {
      const height = elementRef.current.clientHeight - 20;
      setDynamicHeight(height);
    }
  }, [])

  return (
    <div className="w-full h-full flex flex-col">
      <StepsHeader title={"Image Editor"} />
      <div
        className="w-full flex-auto basis-0 overflow-y-auto scrollbar-large"
        ref={elementRef}
      >
        <div className="w-full relative ">
          <div className="w-full h-full p-4">
            <div className="w-full h-full flex ">
              <div className="w-[21.26%] h-full sticky top-4 max-md:w-[35%] ">
                <div
                  className="w-full bg-io-gray-f8 dark:bg-io-black-1c pt-3 flex flex-col overflow-hidden overflow-y-auto scrollbar-none"
                  style={{ height: dynamicHeight }}
                >
                  {isLoading ? (
                    <Skeleton width="100%" height={47} borderRadius={3} />
                  ) : (
                    <div>
                      <ul className="space-y-2 flex flex-col ">
                        <li
                          key={0}
                          onClick={() => setSelectedSidebar(null)}
                          className={`py-[1rem] pl-[1rem] rounded-md cursor-pointer text-[1.5rem] 
                        ${selectedSidebar == null
                              ? "bg-[#ECF4FB]"
                              : "hover:bg-gray-200 text-io-black"
                            }
                      `}
                        >
                          {"Untagged"}
                        </li>
                        {iterationsData.map((item: any, idx: any) => (
                          <li
                            key={idx}
                            onClick={() => setSelectedSidebar(item)}
                            className={`py-[1rem] pl-[1rem] rounded-md cursor-pointer text-[1.5rem] 
                  ${selectedSidebar &&
                                selectedSidebar.iteration === item.iteration
                                ? "bg-[#ECF4FB]"
                                : "hover:bg-gray-200 text-io-black"
                              }
                `}
                          >
                            {`Iteration ${item.iteration}`}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="w-[78.74%] h-auto ml-auto max-md:w-[65%] relative overflow-hidden overflow-y-auto scrollbar-none">
                <div className="">
                  <div className="flex items-center gap-3 absolute top-3 right-10">
                    <button
                      onClick={handlePrevPage}
                      disabled={currentPage === 1}
                      className="px-3 py-1 border rounded-lg shadow hover:bg-gray-100 disabled:opacity-50"
                    >
                      ◀
                    </button>
                    <span className="text-gray-700 font-medium">
                      {currentPage} / {totalPages}
                    </span>
                    <button
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                      className="px-3 py-1 border rounded-lg shadow hover:bg-gray-100 disabled:opacity-50"
                    >
                      ▶
                    </button>
                  </div>
                  <div className="absolute top-3 right-60">
                    {!selectedSidebar && (
                      <SecondaryTextBtn
                        label={"Open Editor"}
                        btnStyle="fill-primary"
                        btnType="button"
                        handleClick={openEditor}
                      />
                    )}
                    {/* {selectedSidebar && selectedSidebar.isTraining == 0 && (
                    <SecondaryTextBtn
                      label={"Start Training"}
                      btnStyle="fill-primary"
                      btnType="button"
                      handleClick={handleStartTraining}
                    />
                  )} */}
                  </div>
                </div>
                <div className="w-full h-auto p-[2rem] max-md:p-[1rem] absolute top-20">
                  <div className="w-full h-full">
                    {isLoading ? (
                      <div>
                        <Skeleton width="100%" height={80} borderRadius={3} count={10} />
                      </div>
                    ) : (
                      <div>
                        {galleryImage.length > 0 ? (
                          <div className="grid grid-cols-4 gap-4">
                            {galleryImage.map((img: any, idx) => (
                              <div
                                key={idx}
                                className="relative w-full h-40 border rounded-lg overflow-hidden shadow hover:scale-105 transition-transform"
                              >
                                <img
                                  src={img.url + sasToken}
                                  alt={`gallery-${idx}`}
                                  className="w-full h-full object-cover"
                                />
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="text-[1.5rem] text-io-gray-66 text text-center">
                            No images found
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fullscreen Editor */}
      {isEditorOpen && (
        <VisionTraining
          iteration={iteration}
          magicCommonData={data}
          handleEditorClose={() => setIsEditorOpen(false)}
        />
      )}

      {/* Footer */}
      <ModalPageFooter
        footerType="steps"
        goToPrevious={handlePrevious}
        goToNext={handleNext}
        handleSaveDraft={handleSaveDraft}
        setData={setData}
        data={data}
      />
    </div>
  );
};


export default ImageEditorWrapper;
